import { FmvReviewComponent } from "@/features/esoPerson/fmvReview/FmvReviewComponent"

export const FmvReviewPage = () => {
  return <FmvReviewComponent />
}
